import { RouterProvider } from '@tanstack/react-router';
import { HelmetProvider } from 'react-helmet-async';

import {
	tryRefreshToken,
	useRefreshOnBuild,
} from '@/templates/basic/auth/Auth.hooks';

import { useInterval } from '@/App.hooks';
import { router } from './App.router';

import '@/App.variables.css';
import './App.css';

function App() {
	// Remove comment to refresh build on logout
	useRefreshOnBuild();
	// const INTERVAL_TIME = 5 * 60 * 1000;
	const INTERVAL_TIME = 30 * 1000;
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);

	const classNames = ['App', 'app-magazine'];

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
